import { Skeleton } from "@/components/ui/baseUi/skeleton"

export function ProgramSubscriberDetailsContentSkeleton() {
  return <Skeleton className="rounded-card mx-4 flex h-150 grow-1" />
}
